import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { MonitorEventListFilters } from "../../../service/ApiMonitorEvent";

export enum GetUserMonitorSubtype {
  LoadNextPage = "LOAD_NEXT_PAGE",
  LoadFirstPage = "LOAD_FIRST_PAGE",
}

export const GET_USER_MONITOR_EVENT_LIST =
  "USER-MONITOR-EVENT:GET_USER_MONITOR_EVENT_LIST";

export interface GetUserMonitorEventListAction extends Action {
  type: typeof GET_USER_MONITOR_EVENT_LIST;
  organization: OrganizationKeyName;
  subtype: GetUserMonitorSubtype;
  filters: MonitorEventListFilters;
}

export const getUserMonitorEventListAction = (
  organization: OrganizationKeyName,
  subtype: GetUserMonitorSubtype,
  filters: MonitorEventListFilters
): GetUserMonitorEventListAction => ({
  type: GET_USER_MONITOR_EVENT_LIST,
  subtype,
  organization,
  filters,
});
